import { Outlet, RouteObject } from 'react-router-dom';
import { BrowserRoute } from '../../routes/browser.routes';
import { Main } from '../components/main';
import { Access } from '../content/access';
import { Auth } from '../content/auth/auth.view';
import { ListOfAnswers } from '../content/ListOfAnswers';
import { NotFound } from '../content/not-found';

export const appRoutesDefinition: RouteObject[] = [{
  path: '/',
  element: (
    <Auth>
      <Access>
        <Outlet />
      </Access>
    </Auth>
  ),
  children: [
    {
      path: '*',
      element: <NotFound />,
    },
    {
      path: BrowserRoute.index,
      element: (
        <Main>
          <ListOfAnswers />
        </Main>
      ),
    },
  ],
}];
